import React, { useState } from "react";
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { overviewChartPalette } from "styles/theme";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { FaRupeeSign } from "react-icons/fa";
import ProcurementPackages from "./ProcurementPackages";
import ProcurementServiceListPopUp from "./procurementServiceListPopUp";
import ProcurementListPopUp from "./procurementBoiListPopup";
import { PROCUREMENT_DASHBOARD_CONFIG } from "config";
import { useParams } from "react-router-dom";



const ServicesKpi = ({ data, isError, isLoading }) => {

  const { projectId } = useParams();
  const [isPackages, setPackages] = useState(false);
  const [headertItem, setHeaderItem] = useState("")
  const [isTotalWorkOrder, setIsTotalWorkOrder] = useState(false);
  const [isPoIssued, setIsPoIssued] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");

   const currentDashboardConfig = PROCUREMENT_DASHBOARD_CONFIG[projectId] || PROCUREMENT_DASHBOARD_CONFIG.default;



  const handleClick = (label) => {
    setSelectedLabel(label);
    setHeaderItem(label)
    if (label === "Services Packages") {
      setPackages(true);
      setIsPoIssued(false);
      setIsTotalWorkOrder(false);
    }
    else if (label === "Total P.O Issued") {
      setIsPoIssued(true);
      setPackages(false);
    }
    else if (label === "Total Work Order") {
      setIsTotalWorkOrder(true);
      setPackages(false);
    }
  };



  const handlePackagesClose = () => {
    setPackages(false);
  };

  const handleListClose = () => {
    setIsPoIssued(false);
    setIsTotalWorkOrder(false)
  };

  const kpis = [
    {
      key: "avg-pr",
      label: "Services Packages",
      value: data?.servicesPackages,
      bg: "#FFF4DE",
      iconBg: overviewChartPalette.coral,
      showBoiKpi:true
    },
    {
      key: "avg-rfq",
      label: "Total Work Order",
      value: data?.totalWorkOrder,
      bg: "#FFF4DE",
      iconBg: overviewChartPalette.amber,
      showBoiKpi:true
    },
    //   {
    //     key: "avg-pr",
    //     label: "Avg PR to PO time",
    //     value: "20 days",
    //     bg: "#FFF4DE",
    //     iconBg: "#FF947A",
    //   },
    {
      key: "total-po",
      label: "Total P.O Issued",
      value: data?.totalPOIssued,
      bg: "#DCFCE7",
      iconBg: overviewChartPalette.teal,
      showBoiKpi:currentDashboardConfig.showBoi
    },
    {
      key: "budget-cost",
      label: "Budgeted Cost",
      value: data?.budgetedCost.toFixed(2),
      // value: "7.27 Cr",
      bg: "#FFF4DE",
      iconBg: overviewChartPalette.cyan,
      // subTexts: [
      //   { label: "Services", value: "200 Cr." },
      //   { label: "Material", value: "90 Cr." },
      // ],
      type: "rupee",
      showBoiKpi:true
    },
    {
      key: "commited-cost",
      label: "Committed Cost",
      value: data?.committedCost.toFixed(2),
      bg: "#F3E8FF",
      iconBg: overviewChartPalette.violet,
      // subTexts: [
      //   { label: "Services", value: "200 Cr." },
      //   { label: "Material", value: "90 Cr." },
      // ],
      type: "rupee",
      showBoiKpi:true
    },
    //   {
    //     key: "rfq-delayed",
    //     label: "Number of RFQ Delayed",
    //     value: "1",
    //     bg: "#FFE2E5",
    //     iconBg: "#FA5A7D",
    //   },
  ];


  const clickable = [
    "Services Packages",
    "Total Work Order",
    "Total P.O Issued",
  ];


  return (
    <Box
      elevation={0}
      sx={{
        borderRadius: "3px",
        border: "1px solid #eef0f4",
        backgroundColor: "#FFFFFF",
        width: "100%",
        boxSizing: "border-box",
        p: "20px 20px 20px 20px",
        maxHeight: { xs: "auto", md: "316px" },
      }}
    >
      <Typography
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          fontSize: "15px",
          lineHeight: "21px",
          letterSpacing: "0px",
          color: "#05004E",
        }}
      >
        Procurement Intelligence
      </Typography>
      <Typography
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: 400,
          fontSize: "12px",
          lineHeight: "16px",
          letterSpacing: "0px",
          color: "#737791",
          mb: 2,
        }}
      >
        Tracks procurement commitments, package progress, and cost exposure.
      </Typography>

      <Grid
        container
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
          gap: 1.25,
          width: "100%",
          "& > .MuiGrid-root": { minWidth: 0, width: "auto", maxWidth: "none" },
          "& .MuiCard-root": { transition: "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease" },
          "& .MuiCard-root:hover": { borderColor: "#CBD5E1", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)", transform: "translateY(-1px)" },
        }}
      >
        {kpis?.filter((item) => item.showBoiKpi !== false).map((item) => (
          <Grid
            xs={12}
            sm={6}
            md={12 / 7}
            key={item.label}
            sx={{ minWidth: 0 }}
          >
            <Card
              elevation={0}
              onClick={() =>
                item.label === "Services Packages" ||
                  item.label === "Total Work Order" ||
                  item.label === "Total P.O Issued"
                  ? handleClick(item.label)
                  : undefined
              }
              sx={{
                height: "128px",
                  position: "relative",
                // width: { minWidth: "200px", minWidth: "100%" },

                borderRadius: "3px",
                backgroundColor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderBottom: `3px solid ${item.iconBg}`,
                cursor: clickable.includes(item.label)
                  ? "pointer"
                  : "default"
              }}
            >
              <CardContent sx={{ gap: 1, p: 1.25, pt: 1.25 }}>
                <Avatar
                  sx={{
                    width: 30,
                    height: 30,
                    backgroundColor: item.iconBg,
                    fontSize: 18,
                    fontWeight: 700,
                  }}
                >
                  {item.type === "rupee" ? <FaRupeeSign /> : <CiCalendar />}
                </Avatar>
                  <DashboardKpiStatus color={item.iconBg} />

                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "13px",
                      mt: "4px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "21px",
                        color:
                          item.type === "percentage" ? "#FF383C" : "#151D48",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Outfit, sans-serif",
                      fontWeight: 500,
                      lineHeight: "16px",
                      fontSize: "12px",
                      letterSpacing: "0px",
                      color: "#425166",
                      mt: "4px",
                    }}
                  >
                    {item.label}
                  </Typography>
                  {item?.subTexts?.length && (
                    <>
                      {item.subTexts.map((subItem) => (
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: "Outfit, sans-serif",
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "#4B5563",
                          }}
                        >
                          {subItem.label}: <strong>₹ {subItem.value}</strong>
                        </Typography>
                      ))}
                    </>
                  )}
                </>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {isPackages && (
        <ProcurementPackages
          open={isPackages}
          handleClose={handlePackagesClose}
        />
      )}

      {isTotalWorkOrder && (
        <ProcurementServiceListPopUp
          header={headertItem}
          open={isTotalWorkOrder}
          handleClose={handleListClose}
          data={{ Status: "Awarded" }}
        />
      )}

      {isPoIssued && (
        <ProcurementListPopUp
          header={headertItem}
          open={isPoIssued}
          handleClose={handleListClose}
          data={{ Status: "Awarded" }}
        />
      )}

    </Box>
  );
};

export default ServicesKpi;
